import * as Handlebars from 'handlebars/runtime';
import formatDate from 'templates/helpers/formatDate';
import ifEquals from 'templates/helpers/ifEquals';
import deviceTypeIcon from 'templates/partials/deviceTypeIcon';
import navbar from 'templates/partials/navbar';
Handlebars.registerHelper({formatDate,ifEquals});
Handlebars.registerPartial({deviceTypeIcon,navbar});
export default Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<table class=\"table table-striped table-hover\">\n	<thead>\n		<tr>\n			<th>Time</th>\n			<th>Team</th>\n			<th class=\"center\">Lang</th>\n			<th>Game</th>\n			<th>State</th>\n		</tr>\n	</thead>\n	<tbody>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sessions") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":1},"end":{"line":45,"column":10}}})) != null ? stack1 : "")
    + "	</tbody>\n</table>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "		<tr class=\"session\" data-id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\">\n			<td>"
    + alias2(lookupProperty(helpers,"formatDate").call(alias3,(depth0 != null ? lookupProperty(depth0,"creation_date") : depth0),"HH:mm",{"name":"formatDate","hash":{},"data":data,"loc":{"start":{"line":25,"column":7},"end":{"line":25,"column":43}}}))
    + "</td>\n			<td>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"team_name") : depth0), depth0))
    + "</td>\n			<td class=\"center\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"languageFlag") : depth0), depth0))
    + "</td>\n			<td>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"game") : depth0), depth0))
    + "</td>\n			<td class=\"stateContainer\">\n"
    + ((stack1 = lookupProperty(helpers,"ifEquals").call(alias3,(depth0 != null ? lookupProperty(depth0,"state") : depth0),"Ended",{"name":"ifEquals","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":30,"column":4},"end":{"line":42,"column":17}}})) != null ? stack1 : "")
    + "			</td>\n		</tr>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "					<div class=\"state ended\"><i class=\"far fa-check-square\"></i> "
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"state") : depth0), depth0))
    + ": "
    + alias1(lookupProperty(helpers,"formatDate").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"end_date") : depth0),"HH:mm",{"name":"formatDate","hash":{},"data":data,"loc":{"start":{"line":31,"column":77},"end":{"line":31,"column":108}}}))
    + "</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"ifEquals").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"state") : depth0),"Running",{"name":"ifEquals","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":33,"column":5},"end":{"line":41,"column":18}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "						<div class=\"state running\"><i class=\"far fa-stopwatch\"></i> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"state") : depth0), depth0))
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"ifEquals").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"state") : depth0),"Pending",{"name":"ifEquals","hash":{},"fn":container.program(9, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":36,"column":6},"end":{"line":40,"column":19}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "							<div class=\"state pending\"><i class=\"far fa-mug-hot\"></i> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"state") : depth0), depth0))
    + "</div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "							<div class=\"state "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"state") : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"state") : depth0), depth0))
    + "</div>\n";
},"13":function(container,depth0,helpers,partials,data) {
    return "<div class=\"message\">No session found.</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<h1>Sessions</h1>\n\n<div id=\"dateSelector\" class=\"btn-group\">\n	<button id=\"dateDisplay\" class=\"btn btn-outline-secondary\"></button>\n	<button class=\"btn btn-outline-secondary calendarIconButton\"><i class=\"far fa-calendar-alt\"></i></button>\n</div>\n\n<a id=\"createButton\" class=\"btn btn-primary\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"createLink") : depth0), depth0))
    + "\"><i class=\"far fa-plus-square\"></i> Create</a>\n\n<div class=\"content\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sessions") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(13, data, 0),"data":data,"loc":{"start":{"line":11,"column":0},"end":{"line":50,"column":7}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});